import { z } from 'zod';
import { ScanResult, ScanType } from './scan';
export const DashboardSummary = z.object({
    totalAttendees: z.number(),
    attendedCount: z.number(),
    lunchClaimedCount: z.number(),
    pendingAttendance: z.number(),
    pendingLunch: z.number(),
    lastScanAt: z.string().datetime().nullable(),
});
export const RecentScan = z.object({
    id: z.string().uuid(),
    type: ScanType,
    // Go copia el enum scan_result tal cual (internal/dashboard/dto.go), REVOKED incluido.
    result: ScanResult,
    scannedAt: z.string().datetime(),
    attendee: z
        .object({
        id: z.string(),
        fullName: z.string(),
    })
        .nullable(),
    attemptedToken: z.string().nullable(),
    by: z.object({
        id: z.string(),
        fullName: z.string(),
    }),
});
export const RecentScansResponse = z.object({
    items: z.array(RecentScan),
    total: z.number(),
});
export const NoShowAttendee = z.object({
    id: z.string().uuid(),
    fullName: z.string(),
    email: z.string(),
    phone: z.string(),
});
export const NoShowResponse = z.object({
    items: z.array(NoShowAttendee),
    total: z.number(),
});
//# sourceMappingURL=dashboard.js.map